import { getDefaultThemeValues } from "./default/index.js";
import { getAlias } from "./alias.js";
const getTheme = (theme = getDefaultThemeValues()) => () => getAlias(theme);
const getDefaultTheme = getTheme();
export {
  getDefaultTheme
};
